import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { ADMIN_ENV, headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { post, get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "agents";

export const getAgents = async (group_number: number) => {
	try {
		const endpoint = `${initialRoute}/particular-group/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			throw error;
		}
	}
};
